export const paginationAdapter = {
  total: 'totalCount'
}

export const tableHeaderCellStyleAdapter = {
  background: '#f9fafc'
}
